import React from "react";
import { getIn } from "formik";

export default class Select extends React.Component<any, any> {
  componentDidMount() {
    const { field, form, list = [] } = this.props;
    if (form.getFieldMeta(field.name).value === undefined) {
      const [elm] = list;
      const value = Array.isArray(elm) ? elm[0] : elm;
      form.setFieldValue(field.name, value);
    }
  }

  onBlur = (args: any) => {
    const { field, onBlur } = this.props;
    field.onBlur(args);

    if (onBlur) onBlur(args);
  };

  onChange = (args: any) => {
    const { field, onChange } = this.props;
    field.onChange(args);

    if (onChange) onChange(args);
  };

  render() {
    const { className, field, form, list = [], ...props } = this.props;
    const { errors, touched } = form;
    const error = getIn(touched, field.name) && getIn(errors, field.name);

    return (
      <>
        <select
          id={field.name}
          className={`${className} ${error ? "red-border" : ""}`}
          {...field}
          {...props}
          onBlur={this.onBlur}
          onChange={this.onChange}
        >
          {list.map((item: any) => {
            const [key = "", title] = Array.isArray(item)
              ? item
              : [item.toLowerCase(), item];
            return (
              <option value={key} key={key}>
                {title}
              </option>
            );
          })}
        </select>
        {error && <span className="text-danger">{error}</span>}
      </>
    );
  }
}
